import { render, staticRenderFns } from "./index.vue?vue&type=template&id=898c5812&scoped=true"
import script from "./create-case.js?vue&type=script&lang=js&external"
export * from "./create-case.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=898c5812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898c5812",
  null
  
)

export default component.exports